const angular = require('angular');
var app = angular.module('learn-controllers');

app.controller('editSurvey', ['Application', 'Authorization', 'AccessHelper', 'Surveys', 'SurveyHelper', '$scope', '$translate', '$location', function(Application, Authorization, AccessHelper, Surveys, SurveyHelper, $scope, $translate, $location) {
    var self = this;

    self.userLanguage = SurveyHelper.getSurveyjsLanguage(Authorization.getAuthToken().user.language);

    self.features = Application.features.flags();
    self.allowance = {
        surveys: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin'])
    };
    self.showCollaborators = false;

    if (!self.allowance.surveys) {
        Application.navigation.goTo('/explore');
        return;
    }


    const addIdToElement = function(elementObject, idString) {
      return {...elementObject, _id: idString};
    }


    const mapPageElementsToQuestionIds = function(pagesArray, questionsArray) {
      // This function assumes that the order and number of questions across pages 
      // matches the order and number of questions in the questions array
      // (The more I think about it, this might need to be refactored to only assign _ids to questions without _ids
      // while still keeping track of the question list index)

      let elementIndex = 0;
      return pagesArray.map(page => {
        const identifiedElements = page.elements.map(element => {
          if (element.type === "panel") {
            const identifiedPanelElements = element.elements.map(panelElement => {
              const panelElementWithId = addIdToElement(panelElement, questionsArray[elementIndex]._id);
              elementIndex++;
              return panelElementWithId;
            })
            return {...element, elements: identifiedPanelElements}
          }
          const elementWithId = addIdToElement(element, questionsArray[elementIndex]._id);
          elementIndex++;
          return elementWithId;
        })
        return {...page, elements: identifiedElements}
      })
    }

    const questionHasBeenUpdatedCheck = function(currentQuestionObject, originalQuestionObject) {
      for (const key in currentQuestionObject) {
        // If question has new keys
        if (!originalQuestionObject[key] && key !== 'name') {
          return currentQuestionObject;
        }
        // if elements of array (choices) don't match
        if (Array.isArray(currentQuestionObject[key])) {
          for (let i = 0; i < currentQuestionObject[key].length; i++) {
            if (currentQuestionObject[key][i] !== originalQuestionObject[key][i]) {
              return currentQuestionObject;
            }
          }
        }
        // if values have changed
        if (currentQuestionObject[key] !== originalQuestionObject[key]) {
          return currentQuestionObject;
        }
      }
      // If nothing has changed in question, just send _id
      return {_id: currentQuestionObject._id};
    }

    const getQuestionObjectStructureForUpdate = function(question, originalQuestionsList) {
      if (!question._id) {
        return question;
      }
      const originalQuestionObject = originalQuestionsList.find(originalQuestionObject => originalQuestionObject._id === question._id);
      return questionHasBeenUpdatedCheck(question, originalQuestionObject);
    }


    self.info = {
      surveyId: Application.navigation.getRouteParameters().id || null,
      currentTab: 'details',
      loading: true,
      rendered: false,
      needToUpdate: false
    }
  
    self.updatedFields = {};

    self.survey = {
      title: '',
      description: '',
      pages: [],
      archived: false,
      content: []
    }
    
    self.navigation = {
      directory: {
        'details': {
          next: 'questions',
          previous: null,
          required: function() {
            var missing = [];
            if (!self.survey.title) {
              missing.push('title');
            }
            if (!self.survey.description) {
              missing.push('description');
            }
            if (missing.length) {
              return missing;
            }
            return null;
          }
        },
        'questions': {
          next: 'settings',
          previous: 'details',
          required: null
        },
        'settings': {
          next: null,
          previous: 'questions',
          required: null
        }
      },
      next: function(option) { 
        option = option || this.directory[self.info.currentTab].next;
        if (!option || !this.directory[option]) {
          return;
        }
        for (var key in this.directory) {
          if (option === key) {
            self.info.currentTab = option;
            setTimeout(function() {
              window.scrollTo(0, 0);
            }, 5);
            return;
          }
          if (this.directory[key].required) {
            var missing = this.directory[key].required();
          }
          if (missing && missing.length) {
            var message = 'The following fields are required: ';
            missing.forEach(function(item, index) {
              message += item;
              if (index === (missing.length - 1)) {
                message += '.';
                return;
              }
              message += ', ';
            });
            Application.messaging.addMessage({type: 'error', duration: 6, text: message});
            return;
          }
        }
      },
      previous: function(option) {
        option = option || this.directory[self.info.currentTab].previous;
        if (!option || !this.directory[option]) {
          return;
        }
        self.info.currentTab = option;
      }
    };

    self.create = async function() {
      const newSurvey = {...self.survey};
      delete newSurvey.content;
      try {
        const createdSurvey = await Surveys.create({}, {survey_json: newSurvey, content: self.content.contentIdList}).$promise;
        self.survey._id = createdSurvey.id;
        Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['edit.surveys.successCreated']});
        self.leave.requested = true;
        Application.navigation.goTo('/overview/surveys');
      } catch (e) {
        console.log(e);
        Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.surveys.errorCreated']});
      }
      $scope.$apply();
    }

    self.update = async function() {
      if (self.originalQuestions && self.updatedFields.pages) {
        // Map through pages, then through each pages elements
        const readyForUpdate = self.updatedFields.pages.map(page => {
          const mappedQuestions = page.elements.map(question => {
            // If question is a panel
            if (question.type === 'panel') {
              const panelElements = question.elements.map(panelQuestion => {
                return getQuestionObjectStructureForUpdate(panelQuestion, self.originalQuestions);
              })
              return {...question, elements: panelElements};
            }
            return getQuestionObjectStructureForUpdate(question, self.originalQuestions);
          })
          return {...page, elements: mappedQuestions};
        })
        // This should be keeping survey_json up to date alongside the actual data for the survey itself
        self.updatedFields.survey_json = {...self.survey.survey_json, ...self.updatedFields, pages: readyForUpdate};
        // Update survey_json with any other updates to the survey
      } else if (Object.keys(self.updatedFields).length) {
        self.updatedFields.survey_json = {...self.survey.survey_json, ...self.updatedFields};
      }
      // Update the content field with just the ids after survey_json is updated to avoid adding a content field to survey_json
      if (self.updatedContent) {
        self.updatedFields.content = self.updatedContent;
      }
      try {
        const updated = await Surveys.update({subresource: self.survey._id}, self.updatedFields)
        self.info.needToUpdate = false;
        Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['edit.surveys.successUpdated']});
      } catch (e) {
        console.log(e);
        Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['edit.surveys.errorUpdated']});
      }
      $scope.$apply();
    }

    self.leave = {
      modal: false,
      requested: false,
      leavePage: function() {
        $location.path(self.info.path.targetPath).search(self.info.path.targetSearch).hash(self.info.path.targetHash);
      },
      saveAndLeavePage: function() {
        // TODO: Think about error handling here (Do we want to navigate to the admin page if update fails)
        const checkRequired = self.navigation.directory.details.required();
        if (checkRequired && checkRequired.length) {
          const message = "The following fields are required: " + checkRequired;
          Application.messaging.addMessage({type: 'error', duration: 6, text: message});
          self.leave.cancel();
          return;
        }
        if (!self.survey._id) {
          self.create();
        } else {
          self.update();
        }
        self.leave.requested = true;
        self.leave.leavePage();
      },
      leavePageNoSave: function() {
        self.leave.requested = true;
        self.leave.leavePage();
      },
      cancel: function() {
        self.leave.modal = false;
        self.leave.requested = false;
      }
    }

    $scope.$on('$locationChangeStart', function(event) {
      if (!self.info.needToUpdate || self.leave.requested) {
        return;
      }
      self.info.path = {};
      self.info.path.targetPath = Application.navigation.getPath();
      self.info.path.targetSearch = Application.navigation.getUrlParameters();
      self.info.path.targetHash = Application.navigation.getHash();

      event.preventDefault();

      self.leave.modal = true;

    })
    
    // Content Association
    self.content = {
      omittedContentTypes: ['assessment', 'survey', 'multi_session_workshop'],
      contentIdList: [],
      mapContentIds: function(content = []) {
        return content.map(item => item._id);
      },
      initialIdsByType: {},
      formatContentLabelText: function() {
        for (const content of self.survey.content) {
          self.content.initialIdsByType[content.type] ??= [];
          self.content.initialIdsByType[content.type].push(content._id.toString());
        }
      },
      resultParse: function(item) {
        if (item.surveys?.length) {
          return false;
        }
        return true;
      }
    }

    self.saveQuestions = function(json) {
      self.survey.pages = json.pages;
      $scope.$apply(); 
    }

    // Watches to track changes
    $scope.$watch('editor.survey.title', (newVal, oldVal) => {
      if (!self.info.rendered) {
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      self.updatedFields.title = newVal;
      self.info.needToUpdate = true;
    })

    $scope.$watch('editor.survey.description', (newVal, oldVal) => {
      if (!self.info.rendered) {
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      self.updatedFields.description = newVal;
      self.info.needToUpdate = true;
    })

    $scope.$watch('editor.survey.pages', (newVal, oldVal) => {
      if (!self.info.rendered) {
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      self.updatedFields.pages = newVal;
      self.info.needToUpdate = true;
    }, true)


    $scope.$watch('editor.survey.content', (newVal, oldVal) => {
      if (!self.info.rendered) {
        return;
      }
      if (newVal === oldVal) {
        return;
      }
      self.content.contentIdList = self.content.mapContentIds(newVal);
      self.updatedContent = self.content.contentIdList;
      self.info.needToUpdate = true;
    }, true);

    self.init = async function() {
      if (self.info.surveyId) {
        const foundSurvey = await Surveys.get({subresource: self.info.surveyId}).$promise;
        self.survey = foundSurvey;
        self.survey.pages = mapPageElementsToQuestionIds(foundSurvey.survey_json.pages, foundSurvey.questions);
        self.survey._id = foundSurvey._id;
        self.originalQuestions = foundSurvey.questions;
        self.showCollaborators = foundSurvey.privacy_collaborators.length > 0;
        self.content.contentIdList = self.content.mapContentIds(self.survey.content);
        self.content.formatContentLabelText();
        self.info.loading = false;
        $scope.$apply();
        self.info.rendered = true;
      }
      self.info.loading = false;
      self.info.rendered = true;
    }

    $translate([
      'edit.surveys.successCreated',
      'edit.surveys.errorCreated',
      'edit.surveys.successUpdated',
      'edit.surveys.errorUpdated'
    ]).then(function(translations) {
      self.translations = translations;
      self.init();
    });
}])